var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5150",
    "data-name": "Group 5150",
    transform: "translate(-292 -647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    transform: "translate(295 650)",
    fill: "#9169df",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(308 663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15040",
    "data-name": "Path 15040",
    d: "M30.642,31.468a9.387,9.387,0,0,1-4.9-1.373A13.914,13.914,0,0,1,19.2,32c-3.764,0-6.027-1.08-7.3-2.057-3.66.894-8.547-.141-9.64-1.629A5.03,5.03,0,0,1,1.724,24.5,12.173,12.173,0,0,1,0,18.134c0-2.777,1-5.822,1.97-8.767A41.337,41.337,0,0,0,3.634,3.361a1.562,1.562,0,0,1,1.387-1.3A50.392,50.392,0,0,0,14.088.115l.16-.05a1.533,1.533,0,0,1,1.632.508l1.387,1.734a1.541,1.541,0,0,1,.213,1.561l-1.113,2.6A1.932,1.932,0,0,1,14.855,9.6h-4.72v1.851a4.705,4.705,0,0,0,.851,2.736,11.012,11.012,0,0,1,1.176,2.075,11.83,11.83,0,0,1,8.107-2.929,9.877,9.877,0,0,1,5.306,1.387A9.031,9.031,0,0,1,30.4,13.334h.24A1.362,1.362,0,0,1,32,14.694V30.108a1.362,1.362,0,0,1-1.36,1.36Zm.293-16.774a.291.291,0,0,0-.293-.293H30.4a7.97,7.97,0,0,0-3.886,1.009A7.607,7.607,0,0,1,28.774,18.5a.533.533,0,0,1-1.011.34A6.8,6.8,0,0,0,25.275,15.8a8.694,8.694,0,0,0-5.007-1.4,10.667,10.667,0,0,0-7.724,2.969A7,7,0,0,1,12.8,19.2c0,3.36-1.134,4.1-1.362,4.213a.556.556,0,0,1-.247.058.533.533,0,0,1-.48-.289.519.519,0,0,1,.225-.708c.007-.008.8-.565.8-3.274a6.009,6.009,0,0,0-.294-1.822,9.6,9.6,0,0,0-1.324-2.574,5.77,5.77,0,0,1-1.048-3.354V9.54A2.941,2.941,0,0,1,6.9,7.75L6.439,6.6A.533.533,0,0,1,7.43,6.2l.458,1.15A1.882,1.882,0,0,0,9.61,8.534h5.245a.861.861,0,0,0,.546-.193.872.872,0,0,0,.3-.5.844.844,0,0,0-.3-.832L15.4,7l-.007,0a.843.843,0,0,0-.468-.191l-3.8-.32a1.345,1.345,0,0,1-1.167-1.76l.208-.624a.534.534,0,0,1,1.013.337l-.208.624A.27.27,0,0,0,11,5.3a.275.275,0,0,0,.21.124l.915.077.73-1.47a.534.534,0,0,1,.955.477l-.544,1.087,1.747.147a1.947,1.947,0,0,1,.458.1l1.024-2.392a.473.473,0,0,0-.064-.48l-1.384-1.73a.465.465,0,0,0-.494-.157l-.16.049A51.389,51.389,0,0,1,5.139,3.116a.5.5,0,0,0-.452.415,42.827,42.827,0,0,1-1.7,6.17c-.943,2.865-1.917,5.827-1.917,8.433A11.067,11.067,0,0,0,2.734,24.1l.008.018a7.214,7.214,0,0,0,.836,1.107.533.533,0,1,1-.754.754c-.006-.006-.063-.065-.151-.165a3.107,3.107,0,0,0,.451,1.872c.719.979,5.227,2.133,8.761,1.162a6.957,6.957,0,0,0,2.205-1.013.533.533,0,1,1,.622.867,7.4,7.4,0,0,1-1.53.823,11.42,11.42,0,0,0,6.02,1.411,13.118,13.118,0,0,0,6.288-1.92,16.547,16.547,0,0,0,2.427-1.681.533.533,0,0,1,.7.8A16.4,16.4,0,0,1,26.8,29.46a8.321,8.321,0,0,0,3.842.941.29.29,0,0,0,.293-.293Z",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15041",
    "data-name": "Path 15041",
    d: "M18.937,40.867a12.392,12.392,0,0,1-3.255.435A13.342,13.342,0,0,1,9.3,39.623a.563.563,0,1,1,.534-.992,11.365,11.365,0,0,0,12.336-.507.563.563,0,1,1,.7.88,11.666,11.666,0,0,1-3.934,1.863Z",
    transform: "translate(4.31 -17.857)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthIcon);
export default __webpack_public_path__ + "static/media/strength-icon.ccf7b191fdee5257650b3def97b81e6d.svg";
export { ForwardRef as ReactComponent };